export default __webpack_public_path__ + "static/media/IndividualSolar.acd14915.jfif";